module.exports = __webpack_public_path__ + "img/brought-to-you-desktop.a771e570.png";